import type { ReactNode } from 'react';
import type { PermissionKey } from '../model/catalog';
import { useCan } from '../model/hooks';

interface CanProps {
  /** Catalog key the children require. */
  permission: PermissionKey;
  children: ReactNode;
  /** Rendered when access is denied (default: nothing). */
  fallback?: ReactNode;
}

/**
 * Render children only when the current user holds `permission`. For a
 * boolean (disable instead of hide, or a prop) use `useCan` directly.
 */
export function Can({ permission, children, fallback = null }: CanProps) {
  const allowed = useCan(permission);
  return <>{allowed ? children : fallback}</>;
}
